import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-185f16ee")

_pushScopeId("data-v-185f16ee")
const _hoisted_1 = { class: "pt-4" }
const _hoisted_2 = { class: "flex flex-row justify-between pb-4" }
const _hoisted_3 = { class: "flex flex-row items-center" }
const _hoisted_4 = { class: "bg-white rounded-lg mr-2" }
const _hoisted_5 = { class: "flex flex-row gap-x-2 justify-between" }
const _hoisted_6 = { class: "pod-table" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_FilterSectionPod = _resolveComponent("FilterSectionPod")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Detail = _resolveComponent("Detail")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Search, {
            class: "search-input",
            placeholder: _ctx.$t('urgentDeliveryManagement.searchPlaceholder'),
            value: _ctx.parameters.search,
            onClear: _ctx.onClear,
            onInput: _ctx.onSearch,
            customMargin: "mr-2"
          }, null, 8, ["placeholder", "value", "onClear", "onInput"]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterOptions, (filter, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index.toString(),
                  class: "cursor-pointer"
                }, [
                  _createVNode("div", {
                    class: ["w-full rounded-lg py-2.5 px-4 text-12px text-center", 
                  `${
                    _ctx.parameters.flags.includes(filter.value)
                      ? 'font-semibold bg-pink-lp-500 text-red-lp-100 border border-red-lp-100'
                      : 'font-semibold bg-white text-gray-lp-300 border border-gray-lp-1600'
                  }`
                ],
                    onClick: () => _ctx.onFilterFlag(filter)
                  }, _toDisplayString(filter.name) + " " + _toDisplayString(_ctx.filterCounter(filter.value)), 11, ["onClick"])
                ]))
              }), 128))
            ])
          ]),
          _createVNode(_component_FilterSectionPod, {
            productType: _ctx.parameters.productType,
            productTypeOptions: _ctx.productTypeOptions,
            startDate: _ctx.parameters.startDate,
            endDate: _ctx.parameters.endDate,
            options: _ctx.lastLocationOptions,
            onApply: _cache[1] || (_cache[1] = payload => _ctx.onApplyFilter(payload, 'productType')),
            onReset: _ctx.onResetFilter
          }, null, 8, ["productType", "productTypeOptions", "startDate", "endDate", "options", "onReset"])
        ]),
        _createVNode(_component_lp_button, {
          icon: "download-new",
          title: _ctx.$t('urgentDeliveryManagement.download'),
          textColor: "red-lp-300",
          customClass: "w-44",
          outline: "",
          small: "",
          class: "right-0",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDownload()))
        }, null, 8, ["title"])
      ]),
      _createVNode("div", _hoisted_6, [
        (_ctx.controller.PODList.length || _ctx.controller.isLoading)
          ? (_openBlock(), _createBlock(_component_TableV2, {
              key: 0,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pagination = $event)),
              loading: _ctx.controller.isLoading,
              columns: _ctx.columns,
              data: _ctx.controller.PODList,
              paginationStyle: "v3",
              pinnedSubstractHeight: "300px",
              onRequest: _cache[4] || (_cache[4] = () => _ctx.fetchList()),
              onClick: _ctx.goToDetail,
              isDetailAble: "",
              headerStyle: "v2",
              bgHeader: "bg-white",
              sortBy: _ctx.parameters.sortBy,
              sortDirection: _ctx.parameters.sortDirection,
              borderTop: false,
              isSpaceTop: false,
              isNoPaddingBottom: "",
              onSort: _ctx.onSort
            }, null, 8, ["pagination", "loading", "columns", "data", "onClick", "sortBy", "sortDirection", "onSort"]))
          : _createCommentVNode("", true),
        (!_ctx.controller.PODList.length && !_ctx.controller.isLoading)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 1,
              customHeaderMessage: _ctx.emptyStateData.headerMessage,
              customMessage: _ctx.emptyStateData.message,
              icon: _ctx.emptyStateData.icon
            }, null, 8, ["customHeaderMessage", "customMessage", "icon"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createVNode(_component_Detail, {
      data: _ctx.urgentDeliveryManagementDetailData,
      close: _ctx.closeDetail
    }, null, 8, ["data", "close"]), [
      [_vShow, _ctx.modalDetail]
    ])
  ], 64))
})